<template>
  <ul class="accordion">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      Accordion: { count: 0, active: null }
    }
  },

  provide () {
    return { Accordion: this.Accordion }
  }
}
</script>

<style lang="scss">
.accordion {
  border-right: thin solid var(--black);
  border-left : thin solid var(--black);
}

.accordion__item {
  position     : relative;
  border-bottom: thin solid var(--black);
  cursor       : pointer;
  user-select  : none;

  &:first-child {
    border-top: thin solid var(--black);
  }
}

.accordion__item-question {
  padding        : 1rem;
  display        : flex;
  justify-content: center;
  align-items    : center;
  font-size      : var(--text-md);
  font-weight    : bold;
  text-transform : uppercase;
  transition     : border .15s linear;

  h6 {
    margin: .125rem 0 0;
  }

  img {
    max-width   : 1.375rem;
    max-height  : 1.375rem;
    margin-right: 1rem;
  }

  &.active {
    border       : medium solid var(--black);
    border-bottom: .25rem solid var(--black);
  }
}

.accordion__item-answer {
  > div {
    padding: 1rem;
  }
}

.accordion {
  &.accordion__item:last-child {
    border-bottom: none;
  }

  .icon-toggle {
    width         : .5rem;
    height        : .5rem;
    margin        : 0 1rem;
    position      : relative;
    display       : inline-block;
    vertical-align: baseline;
    background    : center / cover no-repeat $svg-chevron;

    &.icon--caret {
      background: center / cover no-repeat $svg-caret;
    }
  
    &.active {
      transform: rotate(180deg);
    }
  }
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height,           opacity;
  transition : height 0.3s ease, opacity 0.3s ease;
  overflow   : hidden;
}

.accordion-enter,
.accordion-leave-to {
  height : 0 !important;
  opacity: 0;
}
</style>
